
<div class="page-container" (window:resize)="windowResize()">
  <core-header ></core-header>    
  <core-navigation>
    <router-outlet></router-outlet>
  </core-navigation>
  <core-footer *ngIf="!isViewMobile||isHomePage" ></core-footer>
</div>
<mobile-footer-nav *ngIf="isViewMobile"></mobile-footer-nav> 
